/** Map invite designation label (Executive, Manager, …) to email audience key. */
export function audienceKeyForDesignation(designationLabel, audiences) {
  const wanted = String(designationLabel || "").trim().toLowerCase();
  if (!wanted || !Array.isArray(audiences)) return null;
  for (const a of audiences) {
    for (const d of a.match_designations || []) {
      if (String(d).trim().toLowerCase() === wanted) return a.key;
    }
    if (String(a.label || "").trim().toLowerCase() === wanted) return a.key;
  }
  const fallback = audiences.find((a) => a.is_default) || audiences[0];
  return fallback?.key || null;
}

export function roleGroupOptions(audiences) {
  const options = [{ key: "all", label: "All roles" }];
  for (const a of audiences || []) {
    options.push({
      key: a.key,
      label: a.label,
      hint: (a.match_designations || []).join(", "),
    });
  }
  return options;
}
